import { Fragment } from 'react';
import {
  NODE_COLOR_CLASS,
  TMT_COGNITIVE_TAG,
  TMT_GAME_NAME,
} from '@/pages/tmt-spick/tmtConfig';

interface GuideScreenProps {
  onStart: () => void;
}

const BASIC_ORDER = ['1', '가', '2', '나'];
const COND_ORDER = ['가', '나', '다'];

// 게임 소개 (스픽 공통 스타일)
// - 공통 구조: 태그 → 게임명 → 설명 → 예시 카드 → 게임 시작하기
export default function GuideScreen({ onStart }: GuideScreenProps) {
  return (
    <div className="relative flex flex-col h-full bg-white px-6 animate-fade-in-up overflow-hidden">
      <div className="relative flex-1 min-h-0 overflow-y-auto flex flex-col">
        <div className="m-auto w-full flex flex-col items-center">
          <div className="relative flex flex-col items-center text-center">
            <span className="relative inline-flex items-center h-8 px-4 rounded-full bg-primary-50 text-primary-600 text-[14px] font-bold whitespace-nowrap">
              #{TMT_COGNITIVE_TAG}
            </span>

            <h1 className="relative text-[28px] font-bold text-foreground-950 leading-tight tracking-tight mt-4 text-center">
              {TMT_GAME_NAME}
            </h1>
          </div>

          <p className="text-[15px] leading-relaxed text-foreground-600 mt-3 text-center">
            주어진 조건을 확인하고
            <br />
            순서대로 빠르게 이어주세요.
          </p>

          {/* 예시 카드: 기본 / 조건이 있는 경우를 한 번에 보여준다 */}
          <div className="mt-8 w-full rounded-[28px] bg-background-50 border border-background-200 px-5 py-6">
            {/* 기본 예시 */}
            <div className="flex flex-col items-center">
              <span className="text-[13px] font-bold text-foreground-600 px-3 py-1 rounded-full bg-white border border-background-200 whitespace-nowrap">
                기본
              </span>
              <div className="mt-4 flex items-center justify-center gap-1.5">
                {BASIC_ORDER.map((label, i) => (
                  <Fragment key={label}>
                    {i > 0 && (
                      <i className="ri-arrow-right-line text-primary-400 text-base leading-none" />
                    )}
                    <div className="w-11 h-11 rounded-full bg-primary-500 text-white flex items-center justify-center font-bold text-lg">
                      {label}
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>

            <div className="my-6 h-px bg-background-200" />

            {/* 조건 예시 */}
            <div className="flex flex-col items-center">
              <span className="text-[13px] font-bold text-foreground-600 px-3 py-1 rounded-full bg-white border border-background-200 whitespace-nowrap">
                조건이 있는 경우
              </span>
              <div className="mt-4 flex items-center justify-center gap-1.5">
                {COND_ORDER.map((label, i) => (
                  <Fragment key={label}>
                    {i > 0 && (
                      <i className="ri-arrow-right-line text-primary-400 text-base leading-none" />
                    )}
                    <div
                      className={`w-11 h-11 rounded-[8px] ${NODE_COLOR_CLASS.yellow} flex items-center justify-center font-bold text-lg`}
                    >
                      {label}
                    </div>
                  </Fragment>
                ))}
              </div>
              <p className="mt-3 text-[13px] font-medium text-foreground-500 text-center">
                노란색 네모를 찾아 가 → 나 → 다
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative shrink-0 pt-4 pb-[calc(20px+env(safe-area-inset-bottom))]">
        <button
          onClick={onStart}
          className="w-full h-14 rounded-xl sh-cta text-white font-semibold text-base whitespace-nowrap
            active:scale-[0.99] transition-transform duration-150 cursor-pointer"
        >
          게임 시작하기
        </button>
      </div>
    </div>
  );
}